import Image from 'next/image'
import {useRouter} from 'next/router'
import Link from 'next/link'
import type {JSX} from 'react'
import {Icon as CIcon} from '@/products/flexible-web-toolkit/components/icon'
import {loadImageFromKontentAI} from '@/image-loader'
import {logout, useAuth} from '@/products/auth/auth-provider'
import type {Tersed} from '@/services/kontent-ai/types'
import type {IconContentItem} from '@/products/flexible-web-toolkit/blocks/icon'
import type {
	AuthNavItemLinkContentItem,
	NavItemLinkContentItem,
} from '@/products/flexible-web-toolkit/components/header/models'

interface AccountDropdownProps {
	accountIcon: Tersed<IconContentItem>[]
	greetingText: string
	navLinks: Tersed<AuthNavItemLinkContentItem | NavItemLinkContentItem>[]
}

export const AccountDropdown = ({
	accountIcon,
	greetingText,
	navLinks,
}: AccountDropdownProps): JSX.Element => {
	const authState = useAuth()
	const router = useRouter()
	const {firstName, lastName, salutation} = authState.userDetails
	interface GreetingParams {
		greetingMsg: string
		firstname?: string
		lastname?: string
		praisalution?: string
	}

	function formatGreeting({
		greetingMsg,
		firstname,
		lastname,
		praisalution,
	}: GreetingParams): string {
		if (!greetingText) return ''

		const hasFormalLastName =
			greetingMsg.includes('{{lastName}}') && salutation && lastName

		if (hasFormalLastName) {
			return greetingMsg
				.replace(/{{firstname}}/gi, '')
				.replace(/{{lastName}}/gi, `${praisalution} ${lastname}`)
		}

		return greetingMsg
			.replace(/{{firstname}}/gi, firstname ?? '')
			.replace(/{{lastname}}/gi, lastname ?? '')
	}
	const greetingTexts = formatGreeting({
		greetingMsg: greetingText,
		firstname: firstName,
		lastname: lastName,
		praisalution: salutation,
	})

	return (
		<div className="account-dropdown">
			<button type="button">
				{accountIcon[0]
					? accountIcon.map((icon) => (
							<CIcon
								className="h-8 w-8"
								key={icon.system.id}
								noBackground
								noBorder
							>
								<Image
									alt={
										icon.elements.icon[0]?.description ?? ''
									}
									className="h-8 w-8"
									height={32}
									loader={loadImageFromKontentAI}
									src={icon.elements.icon[0]?.url || ''}
									width={32}
								/>
							</CIcon>
						))
					: null}
				<span>{greetingTexts}</span>
			</button>
			<div className="nav-link-container">
				<ul>
					{navLinks.map((link) => (
						<li key={link.system.id}>
							<Link
								className="inline-block w-full cursor-pointer py-3"
								href={link.elements.url}
								onClick={() => {
									if (
										link.elements.logoutUser[0]
											?.codename === 'yes'
									) {
										logout(router, link.elements.url || '/')
									}
								}}
								passHref
							>
								{}

								{link.elements.text}
							</Link>
						</li>
					))}
				</ul>
			</div>
		</div>
	)
}
